import React, { createContext, useContext, useState } from 'react';

export const DiscreteModeContext = createContext();

export const useDiscreteMode = () => useContext(DiscreteModeContext);

export const DiscreteModeProvider = ({ children }) => {
  const [isDiscreteMode, setDiscreteMode] = useState(false);
  const toggleDiscreteMode = () => setDiscreteMode(!isDiscreteMode);

  return (
    <DiscreteModeContext.Provider value={{ isDiscreteMode, toggleDiscreteMode }}>
      {children}
    </DiscreteModeContext.Provider>
  );
};